<template>
  <div>
    <div class="flex items-center space-x-4">
      <h2>{{ isEditing ? "Editar" : "Crear" }} Franquicia</h2>
    </div>

    <div
      v-if="!loading"
      class="card mt-2"
    >
      <form @submit.prevent="save">
        <section-header title="Datos de Franquicia" />

        <div class="form-field">
          <label for="name">Nombre de franquicia</label>
          <input id="name" type="text" v-model="form.name" />
          <validation-errors :errors="errorFor('name')"></validation-errors>
        </div>

        <section-header title="Datos del Franquiciatario" />

        <div class="form-grid">
          <div class="form-field">
            <label for="franchisee_name">Nombre(s) del Franquiciatario</label>
            <input
              id="franchisee_name"
              type="text"
              v-model="form.franchisee_name"
            />
            <validation-errors
              :errors="errorFor('franchisee_name')"
            ></validation-errors>
          </div>

          <div class="form-field">
            <label for="franchisee_last_name"
              >Apellido(s) del Franquiciatario</label
            >
            <input
              id="franchisee_last_name"
              type="text"
              v-model="form.franchisee_last_name"
            />
            <validation-errors
              :errors="errorFor('franchisee_last_name')"
            ></validation-errors>
          </div>

          <div class="form-field">
            <label for="franchisee_phone">Teléfono del Franquiciatario</label>
            <input
              id="franchisee_phone"
              type="number"
              v-model="form.franchisee_phone"
            />
            <validation-errors
              :errors="errorFor('franchisee_phone')"
            ></validation-errors>
          </div>

          <div class="form-field">
            <label for="email">Correo electrónico del Franquiciatario</label>
            <input id="email" type="email" v-model="form.email" />
            <validation-errors :errors="errorFor('email')"></validation-errors>
          </div>
        </div>

        <section-header title="Seguridad" />

        <div class="flex flex-col w-full">
          <div class="flex justify-between">
            <label for="password">Contraseña</label>
          </div>

          <input id="password" type="password" v-model="form.password" />

          <validation-errors :errors="errorFor('password')"></validation-errors>

          <password-validation
            class="mt-1"
            :password="form.password"
          ></password-validation>
        </div>

        <div class="flex flex-col w-full mt-4">
          <div class="flex justify-between">
            <label for="passwordConfirmation">Confirmar contraseña</label>
          </div>

          <input
            id="passwordConfirmation"
            type="password"
            v-model="form.password_confirmation"
          />

          <password-validation
            class="mt-1"
            :password="form.password"
            :passwordConfirmation="form.password_confirmation"
            :confirmation="true"
          ></password-validation>

          <validation-errors
            :errors="errorFor('password_confirmation')"
          ></validation-errors>
        </div>

        <primary-button type="submit" class="mt-10 mx-0" :loading="loadingForm"
          >{{ isEditing ? "Guardar" : "Crear" }}
        </primary-button>
      </form>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import PasswordValidation from "@/components/ui/PasswordValidation";
import api from "@/api";
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
export default {
  name: "Franchise Form",

  components: {
    PasswordValidation,
  },

  data() {
    return {
      previousRoute: {
        name: "",
        params: {},
      },
      form: {
        name: "",
        franchisee_name: "",
        franchisee_last_name: "",
        franchisee_phone: "",
        email: "",
        password: "",
        password_confirmation: "",
      },
      loading: false,
      loadingForm: false,
      isEditing: false,
    };
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.previousRoute = from.name
        ? { name: from.name, params: from.params }
        : { name: "franchises", params: {} };
    });
  },

  created() {
    this.$store.commit("setSelectedTab", "franchises");
    
    if (this.$route.params.id) {
      this.isEditing = true;
      this.loadFranchise();
    }
  },

  mixins: [validationErrors],

  methods: {
    async loadFranchise() {
      this.loading = true;

      try {
        let franchise = await api.franchises.getById(this.$route.params.id);
        franchise.email = franchise.franchise_users[0].user.email;
        franchise.password = "";
        franchise.password_confirmation = "";

        delete franchise.id;
        delete franchise.user_id;
        delete franchise.franchise_users;
        delete franchise.branches;

        this.form = await JSON.parse(JSON.stringify(franchise));
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    save() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      if (!this.isEditing) {
        this.createFranchise();
      } else {
        this.updateFranchise();
      }
    },

    validateForm() {
      this.errors = {};

      if (!this.form.name) {
        this.errors["name"] = ["Campo requerido"];
      }

      if (!this.form.franchisee_name) {
        this.errors["franchisee_name"] = ["Campo requerido"];
      }

      if (!this.form.franchisee_last_name) {
        this.errors["franchisee_last_name"] = ["Campo requerido"];
      }

      if (!this.form.franchisee_phone) {
        this.errors["franchisee_phone"] = ["Campo requerido"];
      }

      if (!this.form.email) {
        this.errors["email"] = ["Campo requerido"];
      }

      if (
        !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          this.form.email
        )
      ) {
        this.errors["email"] = ["Correo electrónico inválido."];
      }

      if (this.isEditing) {
        if (
          this.form.password !== "" ||
          this.form.password_confirmation != ""
        ) {
          if (!this.form.password) {
            this.errors["password"] = ["Campo requerido"];
          }

          if (
            !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*.])(?=.{8,})/.test(
              this.form.password
            )
          ) {
            this.errors["password"] = ["Contraseña inválida."];
          }

          if (!this.form.password_confirmation) {
            this.errors["password_confirmation"] = ["Campo requerido"];
          }
        }
      } else {
        if (!this.form.password) {
          this.errors["password"] = ["Campo requerido"];
        }

        if (
          !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*.])(?=.{8,})/.test(
            this.form.password
          )
        ) {
          this.errors["password"] = ["Contraseña inválida."];
        }

        if (!this.form.password_confirmation) {
          this.errors["password_confirmation"] = ["Campo requerido"];
        }
      }

      if (this.form.password !== this.form.password_confirmation) {
        this.errors["password_confirmation"] = ["La contraseña no coincide."];
      }

      return Object.keys(this.errors).length === 0;
    },

    async createFranchise() {
      this.loadingForm = true;

      try {
        const response = await api.franchises.create(this.form);
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "franchisesIndex" });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },

    async updateFranchise() {
      this.loadingForm = true;

      try {
        const response = await api.franchises.update(
          this.$route.params.id,
          this.form
        );
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: 'franchisesDetail', params: { franchiseId: this.$route.params.id } });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },
  },
};
</script>